import type { OrderShippingDate } from '../../gql';

import {
    randNumber,
    randBoolean,
    randFutureDate,
    randPastDate,
    randCity,
} from '@ngneat/falso';

const TRANSPORT_CODE_NAMES = ['Sea', 'Air', 'Rail', 'Truck'] as const;

/** Will return a mocked OrderShippingDate object, useful for tests etc. */
const mockShippingDate = (
    overwrite?: Partial<OrderShippingDate>
): OrderShippingDate => {
    const transportIndex = randNumber({ min: 0, max: 3 });
    const includeTransport = randBoolean();

    const baseShippingDate: OrderShippingDate = {
        orderLineNumber: randNumber({ min: 10000000, max: 99999999 }),
        arrivedDate: randBoolean() ? randPastDate() : undefined,
        bookingDate: randBoolean() ? randPastDate() : undefined,
        carrierEta: randBoolean() ? randFutureDate() : undefined,
        gpdDate: randBoolean() ? randFutureDate() : undefined,
        groDate: randBoolean() ? randFutureDate() : undefined,
        pndQty: randBoolean() ? randNumber({ min: 0, max: 10000 }) : undefined,
        portOfLoading: randBoolean() ? randCity() : undefined,
        transportCodeName: includeTransport
            ? TRANSPORT_CODE_NAMES[transportIndex]
            : undefined,
        warehouseEta: randBoolean() ? randFutureDate() : undefined,
    };

    return { ...baseShippingDate, ...overwrite };
};

export { mockShippingDate };
